import { initContract } from '@ts-rest/core';
const c = initContract();
export const websiteStatsContract = c.router({
    getAggregatedStats: {
        method: 'GET',
        path: '/public/website/stats',
        responses: {
            200: c.type(),
            401: c.type(),
        },
    },
    getCountryStats: {
        method: 'GET',
        path: '/public/website/country/:countryCode',
        responses: {
            200: c.type(),
            401: c.type(),
            404: c.type(),
        },
    },
    recommendStandards: {
        method: 'POST',
        path: '/public/website/recommend-standards',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
    generateProfile: {
        method: 'POST',
        path: '/public/website/generate-profile',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
});
//# sourceMappingURL=websiteStats.js.map